import { useContext, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Layout from '../../Component/layout/main-layout';
import GlobalLayout from '../../Component/layout/global-layout';
import { useTranslation } from 'react-i18next';
import { Context } from '../../Store/context';
import NewsLists from '../../Component/news';
import layoutBgImg from '../../Images/layout/news.jpg';
import { Get } from '../../api/services/api_helpers';

const CATEGORY_LIST = [
  { id: 1, category: 'global', name: 'country_news' },
  { id: 2, category: 'local', name: 'judicial_news' },
  { id: 3, category: 'article', name: 'article' },
  { id: 4, link: '/gallery', name: 'photomaterials' },
  // { id: 5, link: '/video', name: 'video' }
];

const RESULTS_PER_PAGE = 10;

const News = () => {
  const { t } = useTranslation();
  const { showError } = useContext(Context);
  const [searchParams, setSearchParams] = useSearchParams();

  const categoryParam = searchParams.get('category') || 'global';
  const pageParam = parseInt(searchParams.get('page') || '1', 10);

  const [allNews, setAllNews] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const fetchNews = async () => {
      setIsLoading(true);
      try {
        const data = await Get(`news/?category=${categoryParam}&page=${pageParam}`);
        setAllNews(data.results);        
        const totalItems = data.count || data.results.length;
        setTotalPages(Math.ceil(totalItems / RESULTS_PER_PAGE));
      } catch (error) {
        showError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchNews();
  }, [searchParams.toString()]);

  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    setSearchParams({ category: categoryParam, page: newPage.toString() });
  };

  const handleCategoryClick = (category) => {
    const currentCategory = searchParams.get('category') || 'global';
    const currentPage = searchParams.get('page') || '1';
    if (category === currentCategory && currentPage === '1') {
      setSearchParams({ category, page: '1', refresh: Date.now().toString() });
    } else {
      setSearchParams({ category, page: '1' });
    }
  };

  return (
    <GlobalLayout
      title={`${t(
        categoryParam === 'global'
          ? 'country_news'
          : categoryParam === 'local'
            ? 'judicial_news'
            : 'article'
      )} - ${t('supreme_court')} ${t('turkmenistan')}`}
      keywords="Täzelikler, Kazyýet täzelikleri, Habarlar, Makalalar, Türkmenistan"
    >
      <div className='mb-20'>
        <Layout
          layoutBgImg={layoutBgImg}
          title={t(
            categoryParam === 'global'
              ? 'country_news'
              : categoryParam === 'local'
                ? 'judicial_news'
                : 'article'
          )}
        />

        <header className='flex justify-center mt-8 media'>
          <ul className='md:flex md:flex-wrap gap-3 bg-white justify-center 
               w-full p-6 text-[14px] dark:text-dark-text dark:bg-dark'>
            {CATEGORY_LIST.map((item) => (
              <li
                key={item.id}
                className='relative py-1 md:py-0 cursor-pointer'
              >
                {item.link ? (
                  <Link
                    to={item.link}
                    className='relative block group p-4 shadow bg-blue dark:bg-dark-box dark:border '
                  >
                    {t(item.name)}
                    <span className='absolute bottom-0 right-0 h-[1.5px] bg-primary transition-all 
                           duration-300 w-0 group-hover:w-full origin-right'></span>
                  </Link>
                ) : (
                  <span
                    onClick={() => handleCategoryClick(item.category)}
                    className={`relative block group p-4 shadow bg-blue dark:bg-dark-box dark:border 
                     ${categoryParam === item.category ? 'text-primary dark:text-white' : ''}`}
                  >
                    {t(item.name)}
                    <span className='absolute bottom-0 right-0 h-[1.5px] bg-primary transition-all 
                                     duration-300 w-0 group-hover:w-full origin-right'>
                     </span>
                  </span>
                )}
              </li>
            ))}
          </ul>
        </header>

        <NewsLists
          key={`${categoryParam}-${pageParam}`}
          news={allNews}
          isLoading={isLoading}
          totalPages={totalPages}
          handlePageChange={handlePageChange}
          currentPage={pageParam}
        />
      </div>
    </GlobalLayout>
  );
};

export default News;
